import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, UsersIcon, LockIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, PRODUCT_IMAGE } from '../data/content';
const TOTAL_CUPOS = 200;
const START_TAKEN = 173;
const DURATION = 27 * 60 + 43;
function pad(n: number) {
  return String(n).padStart(2, '0');
}
export function FinalOffer() {
  const [secondsLeft, setSecondsLeft] = useState(DURATION);
  const [taken, setTaken] = useState(START_TAKEN);
  useEffect(() => {
    const t = window.setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => window.clearInterval(t);
  }, []);
  useEffect(() => {
    const t = window.setInterval(() => {
      setTaken(v => v < TOTAL_CUPOS - 6 ? v + 1 : v);
    }, 24000);
    return () => window.clearInterval(t);
  }, []);
  const remaining = TOTAL_CUPOS - taken;
  const pct = Math.round(taken / TOTAL_CUPOS * 100);
  const mins = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  return <section id="compra" className="scroll-mt-4 px-5 py-8" aria-labelledby="oferta-title" data-id="element-70" data-mp="1r9v77yu1df3">
      <div className="overflow-hidden rounded-3xl border border-[#c9d6cd] bg-white/90 shadow-xl shadow-[#3f5d4e]/10 backdrop-blur-sm" data-id="element-71" data-mp="6p1x8ut6yfx0">
        <div className="bg-[#3f5d4e] px-5 py-4 text-center text-[#f6f3ec]" data-id="element-72" data-mp="gmptxqacxxht">
          <h2 id="oferta-title" className="font-display text-[22px] leading-tight" data-id="element-73" data-mp="go0u7g4lgn46">
            Oferta final — Gimnasia Postural Resuelta
          </h2>
          <p className="mt-1 text-[12px] text-[#cfe0d3]" data-id="element-74" data-mp="pmmcrba2g24y">Pago único · 100% PDF · Entrega inmediata</p>
        </div>

        <div className="space-y-4 p-5" data-id="element-75" data-mp="uf5soew879cx">
          {/* Urgencia */}
          <div className="rounded-2xl border border-[#e0cfc7] bg-[#fdf6f2] p-4" data-id="element-76" data-mp="zcxp9m7tfjng">
            <div className="flex items-center justify-center gap-2 text-[#b4553f]" data-id="element-77" data-mp="14caegdm5t2t7">
              <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="14a7gn7erm5dx" />
              <span className="text-[12px] font-extrabold uppercase tracking-wide" data-id="element-79" data-mp="18eoyh11ke8m2">La oferta termina en</span>
            </div>
            <p className="mt-2 text-center font-display text-[34px] leading-none tabular-nums text-[#b4553f]" data-id="element-80" data-mp="35cfbk327ijtt">
              {pad(mins)}:{pad(secs)}
            </p>

            <div className="mt-4 flex items-center justify-between text-[11.5px] font-semibold text-[#7a5c50]" data-id="element-81" data-mp="3e7v8isy9df3m">
              <span className="flex items-center gap-1.5" data-id="element-82" data-mp="39ek38w93h6dt">
                <UsersIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-83" data-mp="3o4hu5jyesa6p" />
                Cupos con bonos gratis
              </span>
              <span data-id="element-84" data-mp="3j54yc9pk7srz">
                {remaining} / {TOTAL_CUPOS} restantes
              </span>
            </div>
            <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-[#eadfd8]" role="progressbar" aria-valuenow={taken} aria-valuemin={0} aria-valuemax={TOTAL_CUPOS} aria-label="Cupos reclamados" data-id="element-85" data-mp="zihxr4g7qmi">
              <motion.div className="h-full rounded-full bg-[#b4553f]" initial={{
              width: 0
            }} animate={{
              width: `${pct}%`
            }} transition={{
              duration: 0.8,
              ease: 'easeOut'
            }} data-id="element-86" data-mp="1yrw6lzf8ifbt" />
            </div>
            <p className="mt-1.5 text-center text-[11px] text-[#7a5c50]" data-id="element-87" data-mp="1eva50e23jd19">
              {pct}% de los cupos ya reclamados hoy
            </p>
          </div>

          {/* Resumen del pedido */}
          <div className="rounded-2xl border border-[#dfe7e1] bg-[#f8faf8] p-4" data-id="element-88" data-mp="14x415qwqbwtr">
            <p className="text-[12px] font-extrabold uppercase tracking-wide text-[#3f5d4e]" data-id="element-89" data-mp="19xrsyess8hp1">
              Resumen del pedido
            </p>

            <div className="mt-3 flex gap-3 border-b border-[#e4ebe5] pb-3" data-id="element-90" data-mp="vzbkojf9uj4s">
              <img src={PRODUCT_IMAGE} alt="Gimnasia Postural Resuelta" className="h-16 w-16 shrink-0 rounded-lg border border-[#e4ebe5] bg-white object-contain p-1" data-id="element-91" data-mp="10xd3d38scgfq" />
              <div className="flex-1" data-id="element-92" data-mp="2v8iestq45x5m">
                <p className="text-[13px] font-bold text-[#16302a]" data-id="element-93" data-mp="v8vbz4m5q84d">Gimnasia Postural Resuelta</p>
                <p className="text-[11.5px] text-[#6b7b73]" data-id="element-94" data-mp="q8qt57xs11az">6 tomos en PDF · descarga inmediata</p>
              </div>
              <span className="text-[13px] font-bold text-[#16302a]" data-id="element-95" data-mp="l94fixe1dj1n">47 €</span>
            </div>

            <ul className="mt-3 space-y-2" data-id="element-96" data-mp="h9c66igtj8v8">
              {['Bono 1 — Fichas de evaluación postural', 'Bono 2 — Biblioteca de ejercicios correctivos', 'Bono 3 — Programas listos para aplicar', 'Bono 4 — Pack de clases grupales', 'Bono 5 — Cuestionario de detección rápida'].map(b => <li key={b} className="flex items-center justify-between gap-2" data-id="element-97" data-mp="3tqhbj0m791jf">
                  <span className="flex flex-1 items-start gap-2 text-[12.5px] leading-snug text-[#3d4f47]" data-id="element-98" data-mp="3po48ijyu7hqc">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#6f8f7c]" aria-hidden="true" data-id="element-99" data-mp="3korar46fgq8z" />
                    {b}
                  </span>
                  <span className="shrink-0 text-[11.5px] font-extrabold uppercase text-[#6f8f7c]" data-id="element-100" data-mp="206yz54d1p0ui">Gratis</span>
                </li>)}
            </ul>

            <div className="mt-3 flex items-center justify-between border-t border-[#e4ebe5] pt-3" data-id="element-101" data-mp="298zsvr92l4rf">
              <span className="text-[12.5px] font-semibold text-[#6b7b73]" data-id="element-102" data-mp="2e5yn09sqhbpm">Descuento de hoy</span>
              <span className="text-[12.5px] font-bold text-[#b4553f]" data-id="element-103" data-mp="1hhs90w9x96yo">−27 €</span>
            </div>
            <div className="mt-1 flex items-center justify-between" data-id="element-104" data-mp="1ljdtb2oscniw">
              <span className="text-[13px] font-extrabold uppercase tracking-wide text-[#16302a]" data-id="element-105" data-mp="1qhp4bgqth42p">Total</span>
              <span className="font-display text-[20px] font-bold text-[#16302a]" data-id="element-106" data-mp="1v8p36rjhxw7u">20 €</span>
            </div>
          </div>

          {/* Precio + CTA */}
          <div className="text-center" data-id="element-107" data-mp="xqoxyz50jo7v">
            <div className="flex items-end justify-center gap-3" data-id="element-108" data-mp="12rclhau19mxc">
              <span className="text-[18px] font-semibold text-[#9aa8a0] line-through" data-id="element-109" data-mp="12pi3o5e26axh">47 €</span>
              <span className="font-display text-[46px] font-bold leading-none text-[#16302a]" data-id="element-110" data-mp="260fds184y6rn">20 €</span>
            </div>
            <p className="mt-1 text-[12px] font-semibold text-[#6f8f7c]" data-id="element-111" data-mp="2euu36wmdqxoh">Pago único · sin suscripciones</p>

            <a href={CHECKOUT_URL} className="mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-[#b4553f] px-5 py-4 text-[15px] font-extrabold uppercase tracking-wide text-white shadow-lg shadow-[#b4553f]/25 transition active:scale-[0.98] hover:bg-[#9e4936] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#b4553f]/40" data-id="element-112" data-mp="2asytp4uapdzm">
              Quiero mis clases resueltas
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-113" data-mp="1r3y3ldbomy6o" />
            </a>

            <p className="mt-3 flex items-center justify-center gap-1.5 text-[11.5px] text-[#6b7b73]" data-id="element-114" data-mp="37ipuflt6jxdv">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-115" data-mp="32jv3fwl272io" />
              Pago seguro · Acceso al PDF en minutos
            </p>
          </div>
        </div>
      </div>
    </section>;
}